import { createContext, useContext, useState, useEffect } from 'react';
import { loginUser } from '../services/authService';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('admin_user');
    const token = localStorage.getItem('access_token');
    if (storedUser && token) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  async function login(email, password) {
    if (!email || !password) {
      return { success: false, message: 'Email and password are required.' };
    }

    try {
      const response = await loginUser(email, password);

      if (!response.success) {
        return { success: false, message: response.message || 'Login failed.' };
      }

      const { user: userData, accessToken, refreshToken } = response.data;

      localStorage.setItem('access_token', accessToken);
      localStorage.setItem('refresh_token', refreshToken);

      const adminUser = {
        id: userData.id,
        email: userData.email,
        name: userData.email.split('@')[0],
        role: 'Admin',
        avatar: userData.email.charAt(0).toUpperCase(),
      };

      localStorage.setItem('admin_user', JSON.stringify(adminUser));
      setUser(adminUser);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Something went wrong. Please try again.',
      };
    }
  }

  function updateUser(profile) {
    setUser((prev) => {
      if (!prev) return prev;
      const name = profile.name || prev.name;
      const updated = {
        ...prev,
        name,
        email: profile.email || prev.email,
        avatar: name.charAt(0).toUpperCase(),
      };
      localStorage.setItem('admin_user', JSON.stringify(updated));
      return updated;
    });
  }

  function logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('admin_user');
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
